import http from './http.js';

const methods = {
  // `json` and not `body`: ky hands a plain `body` straight to fetch, which
  // stringifies it to "[object Object]" under text/plain, and the server's json
  // parser then leaves the form — captcha token included — empty.
  form: async formData => {
    try {
      const response = await http.post('/api/contact/form', { json: formData });
      return response.status === 200;
    } catch {
      // ky rejects on any non-2xx. Swallowing that here is what lets the caller
      // report the failure instead of leaving the dialog open and silent.
      return false;
    }
  },
};

const error = method => () => {
  throw new Error(`Unkown method: ${method}`);
};

const main = ({ method, ...rest }) => (methods[method] || error(method))(rest);
Object.entries(methods).forEach(([name, fn]) => (main[name] = fn));

export default main;
